import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import BlogPostsTable from "../../components/blog/BlogPostsTable";

const BlogPostsList = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <BlogPostsTable />
        </WrapperSection>
    );
};

export default BlogPostsList;
